module.exports = __webpack_public_path__ + "static/media/conference-catering.088a21d9.jpg";